export default __webpack_public_path__ + "static/media/front.bf19dd4c.png";